import { useEffect, useState } from 'react';

// Real call latency like Discord: WebRTC round-trip time to the media server, falling back to the signalling ping.
let ping: number | null = null;
const subs = new Set<() => void>();
const set = (v: number | null) => { if (v !== ping) { ping = v; subs.forEach(f => f()); } };

async function measure(room: any): Promise<number | null> {
  const pcm = room?.engine?.pcManager;
  for (const t of [pcm?.subscriber, pcm?.publisher]) {
    try {
      const stats: RTCStatsReport | undefined = await (t?.getStats?.() ?? t?.pc?.getStats?.() ?? t?._pc?.getStats?.());
      let rtt: number | null = null;
      stats?.forEach((s: any) => { if (s.type === 'candidate-pair' && (s.nominated || s.selected || s.state === 'succeeded') && typeof s.currentRoundTripTime === 'number') rtt = s.currentRoundTripTime * 1000; });
      if (rtt !== null) return Math.round(rtt);
    } catch {}
  }
  const sig = room?.engine?.client?.rtt;
  return typeof sig === 'number' && sig > 0 ? Math.round(sig) : null;
}

export function trackPing(room: any) {
  let alive = true;
  const tick = async () => { if (!alive) return; const v = await measure(room); if (alive) set(v); };
  void tick();
  const id = setInterval(tick, 3000);
  return () => { alive = false; clearInterval(id); set(null); };
}

export function usePing() {
  const [v, setV] = useState(ping);
  useEffect(() => { const f = () => setV(ping); subs.add(f); return () => { subs.delete(f); }; }, []);
  return v;
}
export const pingLevel = (ms: number | null) => ms === null ? 'unknown' : ms <= 120 ? 'good' : ms <= 250 ? 'ok' : 'bad';
